import { FieldLabel, HeaderDiv } from "../../styledComponents/Components.styles";

export default function LabelField ({
    label,
    value,
    cursor,
}: Readonly<{
    label: string,
    value: string,
    cursor?: string,
}>) {
    return (
        <HeaderDiv style={{display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <FieldLabel variant="header" style={{cursor: cursor ? "pointer" : "default" }} >
                {label}
            </FieldLabel>

            <FieldLabel variant="body" style={{cursor: cursor ? "pointer" : "default" }} >                
                {value}
            </FieldLabel>
            
        </HeaderDiv>
    )
}